function getNewData(date, type, inShow) {
    if (type == 1) { //中文时间显示
        const time = new Date(date)
        const getFullYear = time.getFullYear()
        const getMonth = time.getMonth() < 9 ? ('0' + (time.getMonth() + 1)) : (time.getMonth() + 1)
        const getDate = time.getDate() < 10 ? ('0' + time.getDate()) : time.getDate()
        const getHours = time.getHours() < 10 ? ('0' + time.getHours()) : time.getHours()
        const getMinutes = time.getMinutes() < 10 ? ('0' + time.getMinutes()) : time.getMinutes()
        const getSeconds = time.getSeconds() < 10 ? ('0' + time.getSeconds()) : time.getSeconds()
        if (inShow == 'getMinutes') {
            return `${getFullYear}年${getMonth}月${getDate}日${getHours}:${getMinutes}`
        }
        return `${getFullYear}年${getMonth}月${getDate}日${getHours}:${getMinutes}:${getSeconds}`
    }
}

function timeTransform(time, type) {
    const myTime = new Date(time)
    if (type == 'day') {
        return `${myTime.getFullYear()}年${myTime.getMonth() + 1}月${myTime.getDate()}日`
    }
    return `${myTime.getFullYear()}年${myTime.getMonth() + 1}月${myTime.getDate()}日${myTime.getHours()}:${myTime.getMinutes()}:${myTime.getSeconds()}`
}

function getColorType(type) {
    const colorS = [{
        bg: '#528FCC',
        graph_bg: '#006ED9',
        text_bg: '#528FCC'
    },
    {
        bg: '#7852CC',
        graph_bg: '#4900E8',
        text_bg: '#7852CC'
    },
    {
        bg: '#C052CC',
        graph_bg: '#B52DC4',
        text_bg: '#C052CC'
    },
    {
        bg: '#E65C5C',
        graph_bg: '#B83232',
        text_bg: '#E65C5C'
    },
    {
        bg: '#CC8672',
        graph_bg: '#FFA78F',
        text_bg: '#CC8672'
    },
    {
        bg: '#E67129',
        graph_bg: '#FFA200',
        text_bg: '#C78800'
    },
    {
        bg: '#E6C35C',
        graph_bg: '#FFC500',
        text_bg: '#FFDD2B'
    }
    ]
    return colorS[type]
}


export {
    getNewData,
    timeTransform,
    getColorType
};

export default {
    getNewData,
    timeTransform,
    getColorType
}


// WEBPACK FOOTER //
// ./src/lib/fragment.js